// please use the "domain/action" naming convention

// Account
export const LOGIN_SUCCESS = 'account/loginSuccess';
export const SILENT_LOGIN = 'account/silentLogin';
export const LOGOUT = 'account/logout';
export const UPDATE_NEXWAY_STATE = 'account/updateNexwayState';
export const UPDATE_INCLUDES_DEFAULT = 'account/updateIncludesDefault';
export const SET_REALM = 'account/setRealm';
export const SET_SELECTED_CUSTOMER = 'account/setSelectedCustomer';

// Table Data
export const SET_TABLE_SCOPE = 'table/setScope';
export const REFRESH_TABLE = 'table/refresh';
export const INC_TABLE_DATA_VERSION = 'table/incVersion';
export const SET_TABLE_FILTERS = 'table/setFilters';
export const SET_ORDER_CREATE_DATE_LIMIT_FILTER = 'table/setOrderCreateDateLimitFilter';

export const DELETE_TABLE_FILTER = 'table/deleteFilter';
export const SET_TABLE_SEARCH = 'table/setSearch';

export const SET_TABLE_CONFIG_VIEWS = 'table/setConfigViews';

export const RESET_TABLE_FILTERS = 'table/resetFilters';
export const RESET_TABLE_SEARCH = 'table/resetSearch';
export const SET_TABLE_ROWS_PER_PAGE = 'table/setRowsPerPage';
export const SET_TABLE_CHECKED_ITEMS_DATA = 'table/setCheckedItemsData';
export const SET_TABLE_CUR_CHECKED_ITEMS_DATA = 'table/setCurCheckedItemsData';
export const SET_HEADER_CUSTOMER_NAME = 'table/setHeaderCustomerName';

export const SET_WAS_UPDATED = 'table/setWasUpdated';
export const SET_TABLE_CURRENT_PAGE = 'table/setCurrentPage';

export const SET_TABLE_META = 'table/setTableMeta';

export const SET_TABLE_COLUMN_ORDERING = 'table/setTableColumnOrdering';

// Show Columns
export const SET_TABLE_SHOW_COLUMNS = 'showColumns/setShowColumns';

// SessionData
export const REQUEST_LOCALES = 'session/requestLocales';
export const REQUEST_COUNTRIES = 'session/requestCountries';
export const REQUEST_LEGAL_ENTITIES = 'session/requestLegalEntities';
export const REQUEST_CURRENCIES = 'session/requestCurrencies';

// TempData
export const UPDATE_TEMP_STATE = 'data/updateTempState';
